import { render, staticRenderFns } from "./popurchase.vue?vue&type=template&id=98dd1b12"
import script from "./popurchase.vue?vue&type=script&lang=js"
export * from "./popurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports